import _ from 'lodash';
import voca from 'voca';

const fetchPersonnel = ({ personnelId }) =>
  axios.get(`/personnel/${personnelId}?with_course_connections=true`);

const fetchPersonnelTraining = ({ personnelId }) =>
  axios.get(`/personnel/${personnelId}/trainings`);

const fetchPersonnelSubordinates = ({ pageParam, personnelId }) =>
  axios.get(`/personnel/${personnelId}/subordinates`, {
    params: { page: pageParam },
  });

const fetchAvailableFields = () =>
  axios.get('/custom_fields/available_field_attributes');

const indexResources = ({ path, resources }) =>
  resources.reduce((acc, resource) => {
    const index = _.get(resource, path);

    if (index) acc[index] = resource;
    return acc;
  }, {});

const groupResources = ({ path, resources }) =>
  resources.reduce((acc, resource) => {
    const group = _.get(resource, path);

    if (group) {
      if (!Object.prototype.hasOwnProperty.call(acc, group)) acc[group] = [];
      acc[group].push(resource);
    }
    return acc;
  }, {});

const formatResources = ({ options = {}, resources }) => {
  const formattedResources = {};

  if (options.resources) formattedResources.resources = resources;
  if (options.ids)
    formattedResources.ids = resources.map((resource) => resource.id);

  Object.keys(options)
    .filter((key) => voca.startsWith(key, 'indexedBy'))
    .forEach((key) => {
      formattedResources[key] = indexResources({
        resources,
        path: options[key].path,
      });
    });

  Object.keys(options)
    .filter((key) => voca.startsWith(key, 'groupedBy'))
    .forEach((key) => {
      formattedResources[key] = groupResources({
        resources,
        path: options[key].path,
      });
    });

  return formattedResources;
};

const filterIncluded = ({ included, type }) =>
  included.filter((inclusion) => inclusion.type === type);

export {
  fetchPersonnel,
  fetchPersonnelTraining,
  fetchPersonnelSubordinates,
  fetchAvailableFields,
  indexResources,
  groupResources,
  formatResources,
  filterIncluded,
};
